import { NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, HostBinding, Input, TemplateRef } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { AttenteOperationComponent, ValCarteComponent } from '../../../../../../val-ammon-composants/val-composants-lib/src/public-api';

// Carte de dashboard : surcouche de la carte générique apportant un en-tête de titre,
// un corps de contenu et le positionnement dans la grille du dashboard.
// Orchestre également les états de chargement, d'erreur et d'absence de données ;
// le contenu n'est affiché qu'en cas de succès avec données.
//
// Le contenu est fourni par un <ng-template> et non par projection de contenu : il n'est ainsi
// instancié qu'au moment où il est réellement rendu, à sa position définitive dans le DOM.
// Un <ng-content> placé sous un bloc @if serait créé de façon anticipée par le composant appelant,
// donc détaché du DOM : tout composant qui se mesure à l'initialisation (graphe Kendo, grille…)
// y verrait un conteneur de taille nulle et se dessinerait à sa taille de repli.
@Component({
	selector: 'val-carte-dashboard',
	imports: [ValCarteComponent, AttenteOperationComponent, TranslocoModule, NgTemplateOutlet],
	templateUrl: './carte-dashboard.component.html',
	styleUrl: './carte-dashboard.component.scss'
})
export class CarteDashboardComponent {

	constructor() {
		this.titre = '';
		this.colonnes = 2;
		this.lignes = 1;
		this.chargementEnCours = false;
		this.estEnErreur = false;
		this.estVide = false;
	}

	// Titre affiché dans l'en-tête de la carte
	@Input()
	public titre: string;

	// Nombre de colonnes occupées dans la grille du dashboard (sur 12)
	@Input()
	public colonnes: number;

	// Nombre de lignes occupées dans la grille du dashboard
	@Input()
	public lignes: number;

	// Indique si le chargement des données est en cours
	@Input()
	public chargementEnCours: boolean;

	// Indique si le dernier chargement s'est soldé par une erreur
	@Input()
	public estEnErreur: boolean;

	// Indique si le chargement a réussi mais qu'aucune donnée n'est à afficher
	@Input()
	public estVide: boolean;

	// Message optionnel affiché à la place du message générique "aucune donnée" (texte déjà résolu)
	@Input()
	public messageVide?: string;

	// Message optionnel affiché à la place du message générique d'erreur (texte déjà résolu)
	@Input()
	public messageErreur?: string;

	// Contenu de la carte, déclaré par l'appelant sous forme de <ng-template> enfant direct
	@ContentChild(TemplateRef, { descendants: false })
	public contenu?: TemplateRef<unknown>;

	@HostBinding('style.grid-column')
	public get gridColumn(): string {
		return `span ${this.colonnes}`;
	}

	@HostBinding('style.grid-row')
	public get gridRow(): string {
		return `span ${this.lignes}`;
	}
}
